import HomeOutlinedIcon from '@mui/icons-material/HomeOutlined';
import ReceiptLongOutlinedIcon from '@mui/icons-material/ReceiptLongOutlined';
import { QuestionAnswerOutlined } from '@mui/icons-material';
import { useTranslation } from '../../hooks/useTranslation';
import BaseSidebar, { CustomSubMenu, Item } from './BaseSidebar';
import PercentOutlinedIcon from '@mui/icons-material/PercentOutlined';
import PersonAddAltOutlinedIcon from '@mui/icons-material/PersonAddAltOutlined';
import DescriptionOutlinedIcon from '@mui/icons-material/DescriptionOutlined';
import { useAccessStage } from '../../context/AccessStageContext';

const SidebarAdmin = () => {
  const { t } = useTranslation();
  const { accessStage } = useAccessStage();

  const isLocked = accessStage !== 'APPROVED';

  return (
    <BaseSidebar includeHeight={true}>
      {({ selectedSubmenu, setSelectedSubmenu }) => (
        <>
          <Item
            title={t('sidebar.dashboard')}
            to="/app/dashboard"
            icon={<HomeOutlinedIcon />}
            setSelectedSubmenu={setSelectedSubmenu}
          />

          <CustomSubMenu
            title={t('sidebar.redScore')}
            icon={<ReceiptLongOutlinedIcon />}
            selectedSubmenu={selectedSubmenu}
            setSelectedSubmenu={setSelectedSubmenu}
            submenuKey="redScore"
          >
            <Item
              title={t('sidebar.consult')}
              to="/app/redscore"
              submenuKey="redScore"
              setSelectedSubmenu={setSelectedSubmenu}
            />
            <Item
              title={t('sidebar.reload')}
              to="/app/redutoconsultas"
              submenuKey="redScore"
              setSelectedSubmenu={setSelectedSubmenu}
            />
            <Item
              title={t('sidebar.history')}
              to="/app/consultas/redscore"
              submenuKey="redScore"
              setSelectedSubmenu={setSelectedSubmenu}
            />
          </CustomSubMenu>

          <CustomSubMenu
            title={t('sidebar.simulations')}
            tag="Beta"
            tagColor="success"
            icon={<PercentOutlinedIcon />}
            selectedSubmenu={selectedSubmenu}
            setSelectedSubmenu={setSelectedSubmenu}
            submenuKey="simulations"
            disabled={isLocked}
          >
            <Item
              title={t('sidebar.redRural')}
              to="/app/redrural"
              submenuKey="simulations"
              setSelectedSubmenu={setSelectedSubmenu}
              disabled={isLocked}
              
            />
          </CustomSubMenu>

          <CustomSubMenu
            title={t('sidebar.registrations')}
            icon={<PersonAddAltOutlinedIcon />}
            selectedSubmenu={selectedSubmenu}
            setSelectedSubmenu={setSelectedSubmenu}
            submenuKey="registrations"
            disabled={isLocked}
          >
            <Item
              title={t('sidebar.clientRegistrations')}
              to="/app/customers"
              submenuKey="registrations"
              setSelectedSubmenu={setSelectedSubmenu}
              disabled={isLocked}
            />
          </CustomSubMenu>

          <Item
            title={t('sidebar.contracts')}
            to="/app/contratos"
            icon={<DescriptionOutlinedIcon />}
            setSelectedSubmenu={setSelectedSubmenu}
          />

          <Item
            title={t('sidebar.faq')}
            to="/app/help"
            icon={<QuestionAnswerOutlined />}
            setSelectedSubmenu={setSelectedSubmenu}
          />
        </>
      )}
    </BaseSidebar>
  );
};

export default SidebarAdmin;
